import { css } from '@emotion/react';
import { color, Icon, Typography } from '@uniquegood/realworld-studio-design';

interface CreditLabelProps {
  credit: number;
}

function CreditLabel({ credit }: CreditLabelProps) {
  return (
    <div css={container}>
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id="credit-label-icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#4a41ff', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#22f8e2', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      </svg>
      <div css={iconWrapper}>
        <Icon icon="special_solid" size="24px" />
      </div>
      <Typography as="span" type="body" css={creditText}>
        {credit} <span css={creditLabel}>크레딧</span>
      </Typography>
    </div>
  );
}

export default CreditLabel;

const container = css`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${color.surface_default_default};
  border-radius: 0;
`;

const iconWrapper = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  svg {
    fill: url(#credit-label-icon-gradient) !important;
  }

  path {
    fill: url(#credit-label-icon-gradient) !important;
  }
`;

const creditText = css`
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: ${color.text_default};
`;

const creditLabel = css`
  color: #8f8f8f;
`;
